<template>
    <div class="container">
        <div class="row py-5">
            <div class="col-12"><h1 class="pstitle">{{usedBoatTitle}}</h1></div>
        </div>
        <div class="row">
            <div v-for="boat in boats.data"
                 :key="boat.id"
                 class="col-12 col-sm-6 col-md-3">
                <boat-card :boat="boat" show-compare="false"></boat-card>
            </div>
            <div v-if="(boats == null || boats.length == 0) && loading === false" class="col-12">
                <p>
                    {{noUsedBoat}}
                    <a href="/Inventory/New">{{newInventory}}</a>
                </p>
            </div>
            <div v-else>
                <pagination v-model="this.boats.page" :records="this.boats.totalCount" :per-page="this.boats.pageSize" @paginate="getNextPage" aria-label="Pagination" />
            </div>
        </div>
    </div>
</template>

<script>
    import getEndPoint, { usedBoats } from "../../constants/api.config";
    import Pagination from "v-pagination-3";
    import { boatsPageSize, usedBoatTitle, noUsedBoat, newInventory } from "../../constants/labels.config";
    import BoatCard from '../../components/atoms/BoatCard';
    export default {
        name: "UsedBoat",
        components: {
            Pagination,
            BoatCard
        },
        data() {
            return {
                boats: {
                    totalCount: 0,
                    pageCount: 0,
                    page: 0,
                    pageSize: 0,
                    data: [],
                },
                loading: false,
                boatsPageSize,
                usedBoatTitle,
                noUsedBoat,
                newInventory,
            };
        },
        methods: {
            getNextPage(event) {
                this.getUsedBoats(event);
            },
            getUsedBoats(pageNumber) {
                this.loading = true;
                this.axios
                    .get(getEndPoint(usedBoats) +"DealerLocationID=" +window.DEALER_LOCATION.dealerLocationID +"&PageSize=" +this.boatsPageSize +"&PageNo=" +pageNumber)
                    .then((response) => {
                        this.loading = false;
                        this.boats = response.data;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.loading = false;
                    });
            }
        },
        mounted() {
            this.getUsedBoats(1);
        },
    };
</script>
<style lang="scss">
    img {
        max-width: 100%;
        max-height: 100%;
        display: block; /* remove extra space below image */
    }

</style>